export const UPDATE_PROGRESS_LOG = 'UPDATE_PROGRESS_LOG';
export const UPDATE_PROGRESS_SPAN = 'UPDATE_PROGRESS_SPAN';
